import { render, staticRenderFns } from "./SPillSeparator.vue?vue&type=template&id=7334c496&scoped=true&"
import script from "./SPillSeparator.vue?vue&type=script&lang=js&"
export * from "./SPillSeparator.vue?vue&type=script&lang=js&"
import style0 from "./SPillSeparator.vue?vue&type=style&index=0&id=7334c496&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7334c496",
  null
  
)

export default component.exports